import { __ } from '@wordpress/i18n'

export default {
  message: __('React is working in plugin :)', 'dhsv_theme'),
  allCategories: __('Alle Projekttypen', 'dhsv_theme'),
  buttonText: __('Projektdetails', 'dhsv_theme'),
  bauort: __('Bauort: ', 'dhsv_theme'),
  architekt: __('Planung: ', 'dhsv_theme'),
  montage: __('Montage-Termin: ', 'dhsv_theme'),
  switchText: __('nur bereits realisierte Projekte', 'dhsv_theme'),
  link_title: __('Mehr erfahren', 'dhsv_theme'),
  tag_des_offenen_holzhauses: __('Tag des offenen Holzhauses', 'dhsv_theme'),
}
